var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSmtpSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.03 15.2",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26452",
    "data-name": "Group 26452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26451",
    "data-name": "Group 26451",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46849",
    "data-name": "Path 46849",
    d: "M665.58,375.71v14.42h18V375.71L675,383.32Z",
    transform: "translate(-665.58 -374.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46850",
    "data-name": "Path 46850",
    d: "M665.83,374.93h17.52L675,382.08Z",
    transform: "translate(-665.58 -374.93)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46851",
    "data-name": "Path 46851",
    d: "M677.89,384.71h-8.21L672,383",
    transform: "translate(-665.58 -374.93)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46852",
    "data-name": "Path 46852",
    d: "M671.68,387h8.21l-2.27,1.72",
    transform: "translate(-665.58 -374.93)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.7
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSmtpSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_smtpSettings.945244c99b24535a6edfdea37a781e59.svg";